import { AutoCompleteOption } from '@modules/common/components/AutoCompleteOption';
import { CategoryIcon } from '@modules/common/components/CategoryIcon';
import { CircularLoader } from '@modules/common/components/CircularLoader';
import { FieldIcon } from '@modules/common/components/FieldIcon';
import { mapEdgeCategoryToCategory } from '@modules/common/utils';
import { Box } from '@mui/material';
import { EqlFieldValue } from 'generated/graphql';
import { ListChildComponentProps } from 'react-window';

interface EqlFieldValuesVirtualListRowProps extends ListChildComponentProps {
  shouldShowCheckbox: boolean;
  shouldShowCategoryIcon?: boolean;
}

export const EqlFieldValuesVirtualListRow = (
  props: EqlFieldValuesVirtualListRowProps,
) => {
  const { data, index, style, shouldShowCheckbox, shouldShowCategoryIcon } =
    props;
  const rowComponent = data[index];

  if (!rowComponent) {
    return <CircularLoader stackProps={{ style }} />;
  }

  const baseProps = rowComponent[0];
  const option: EqlFieldValue = rowComponent[1];
  const { inputValue, selected } = rowComponent[2];
  const inlineStyle = {
    ...style,
    top: style.top as number,
    listStyleType: 'none',
  };

  const renderLabelAvatar = () => {
    if (option.iconURL) {
      return (
        <Box sx={{ pr: 1 }}>
          <FieldIcon iconURL={option.iconURL} />
        </Box>
      );
    }

    if (shouldShowCategoryIcon && option.category) {
      return (
        <Box sx={{ pr: 1 }}>
          <CategoryIcon category={mapEdgeCategoryToCategory(option.category)} />
        </Box>
      );
    }

    return <></>;
  };

  return (
    <AutoCompleteOption
      style={inlineStyle}
      key={String(option.value)}
      option={{ id: option.value, displayName: option.displayName }}
      baseProps={baseProps}
      searchTerm={inputValue}
      showCheckbox={shouldShowCheckbox}
      selected={selected}
      shouldTruncate
      renderLabelAvatar={renderLabelAvatar}
    />
  );
};
